import _extends from "@babel/runtime/helpers/extends";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import get from 'lodash/get';
import ElementImpression from './element-impression';

var CCElementImpression = function CCElementImpression(props) {
  var elementImpressionProps = _objectSpread({
    eventName: 'CC_ELEMENT_IMPRESSION_EVENT'
  }, props);

  var ccData = {
    // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
    productId: props.productId,
    // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
    productImpressionId: props.productImpressionId
  };
  return /*#__PURE__*/React.createElement(ElementImpression, _extends({
    verticalImpressionData: ccData
  }, elementImpressionProps));
};

CCElementImpression.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  productId: PropTypes.number.isRequired,
  productImpressionId: PropTypes.string,
  productImpressionKey: PropTypes.string
};
export default CCElementImpression;
var CCElementImpressionConnect = connect(function (state, ownProps) {
  return {
    productImpressionId: get(state, "impressions[".concat(ownProps.productImpressionKey, "].impressionHeader.impressionId"))
  };
})(CCElementImpression);
export { CCElementImpressionConnect };